import React from 'react';
import type PlanSummaryType from '@jira/spa-apps__advanced-roadmaps-plan-summary/src/PlanSummaryWithErrorBoundary.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSummary: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof PlanSummaryType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-summary", jiraSpaEntry: "async-plan-summary" */ '@jira/spa-apps__advanced-roadmaps-plan-summary/src/PlanSummaryWithErrorBoundary.tsx'
			),
		),
	{ ssr: false },
);

const AsyncPlanSummary = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanSummary} pageId="plan-summary" shouldShowSpinner />
);

export default AsyncPlanSummary;
